import { render, staticRenderFns } from "./UiChip.vue?vue&type=template&id=731a119d&scoped=true&"
import script from "./UiChip.vue?vue&type=script&lang=js&"
export * from "./UiChip.vue?vue&type=script&lang=js&"
import style0 from "./UiChip.vue?vue&type=style&index=0&id=731a119d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731a119d",
  null
  
)

export default component.exports